import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { identityServices } from '../identityServices'

import { ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'

export function useRequestYourData(options?: IOptionsUseMutation<string>) {
  const { t } = useTranslation()

  const mutation = useMutation<unknown, ErrorDetail, unknown>({
    mutationFn: () => identityServices.requestYourData(),
    onSuccess: () => {
      if (options?.onSuccess) {
        options.onSuccess('')
      }
    },
    onError: (err) => {
      if (options?.onError)
        options?.onError({
          ...err,
          errorMessage: t('api:errors.somethingWrong'),
        })
    },
  })

  async function requestYourData() {
    mutation.mutate(null)
  }

  return {
    requestYourData,
    ...mutation,
  }
}
